module.exports = __webpack_public_path__ + "img/VillaLoreto_Paddle.ef5c2ea6.jpg";